import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { FeatureType } from './../../../shared/enums/feature-type.enum';
import { ApplicationInsightsService } from './../application-insights/application-insights.service';

@Injectable()
export class AuthorizationService {
  private featureAccessListCache = '';

  constructor(
    private oauthService: OAuthService,
    private _applicationInsightsService: ApplicationInsightsService
  ) {}

  public Logout() {
    this._applicationInsightsService.clearUserId();
    this.oauthService.logOut();
  }

  get FullName() {
    var claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
  }
  get userRole() {
    var claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['role'];
  }

  get userId() {
    var claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['userId'];
  }

  get email() {
    var claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['email'];
  }

  get authToken() {
    return this.oauthService.getAccessToken();
  }

  get isLoggedIn() {
    return this.oauthService.hasValidAccessToken();
  }

  get featureAccessList() {
    let claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['featureAccessList'];
  }

  hasPermission(featureName: FeatureType): boolean {
    const featureTypeName = FeatureType[featureName];

    if (
      typeof this.featureAccessListCache !== undefined &&
      this.featureAccessListCache.length === 0
    ) {
      this.featureAccessListCache = this.featureAccessList;
    }

    if (this.featureAccessListCache.indexOf(featureTypeName) === -1) {
      return false;
    }
    return true;
  }
}
